import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Button from './Button'

class ButtonBinder extends Component{

  render(){
    return <Button></Button>
  }
}
export default ButtonBinder



// WEBPACK FOOTER //
// ./src/topModule/ButtonBinder.js